import React from 'react'
import { Link } from "react-router-dom";
import logo from '../assets/img/logo.png'
import logoW from '../assets/img/logo-white.png'



export const Header = () => {
  return (


    <header className="main-header header-style-one">
    <div className="logo-desktop">
      <div className="logo"><Link to="/"><img src={logo} alt="Guvercinlik Balik Turu Logo"/></Link></div>
    </div>
    <div className="header-upper">
      <div className="outer-container">
        <div className="inner clearfix">
          {/*Logo*/}
          <div className="logo-box">
            <div className="logo"><Link to="/"><img src={logoW} alt="Guvercinlik Balik Turu Logo"  /></Link></div>
          </div>
          <div className="nav-content clearfix">
            <div className="nav-outer clearfix">

            </div>
            <div className="sticky-header">
        <div className="auto-container clearfix">
          {/*Logo*/}
          <div className="logo pull-left">
            <Link to="/"><img src={logo} alt="Güvercinlik Balık Turu Logo"  style={{height: '80px'}} /></Link>
          </div>
          {/*Right Col*/}
          <div className="pull-right clearfix">
            {/*Book Btn*/}
            <div className="booking-link">
            <ul className="clearfix">
                <li className="phone"><a href="https://wa.me/05336809936"><span className="icon fa fa-whatsapp"></span></a><a href="tel:+905336809936"><span className="icon fa fa-whatsapp" /> 0533 680 99 36</a></li>
                <li className="email"><a href="mailto:iletisim@guvercinlikbalikturu.com"><span className="icon fa fa-envelope" /> iletisim@guvercinlikbalikturu.com</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
          </div>
        </div>
      </div>
    </div>
    {/* Header Top */}
    <div className="header-top header-top-one">
      <div className="outer-container">
        <div className="inner clearfix">
          <div className="top-right clearfix">
            {/*Info*/}
            <div className="info">
              <ul className="clearfix">
                <li className="phone"><a href="https://wa.me/05336809936"><span className="icon fa fa-whatsapp"></span></a><a href="tel:+905336809936"><span className="icon fa fa-mobile" /> 0533 680 99 36</a></li>
                <li className="email"><a href="mailto:iletisim@guvercinlikbalikturu.com"><span className="icon fa fa-envelope" /> iletisim@guvercinlikbalikturu.com</a></li>
              </ul>
            </div>
          
          </div>
        
        </div>
      </div>
    </div>
    {/* Header Upper */}
 
  </header>
  


  )
}
